import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=5765039d&scoped=true"
import script from "./Game.vue?vue&type=script&lang=ts"
export * from "./Game.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Game.vue?vue&type=style&index=0&id=5765039d&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5765039d",
  "3ff2d977"
  
)

export default component.exports